<div class="card">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h3 class="fw-bold">{{ 'specialOffers.preview.information.documents' | translate }}</h3>
            <button class="btn m-outline-btn" (click)="downloadAllDocuments()">
                <i class="app-icon icon icon-download icon-xl me-3"></i>
                <span>{{ 'specialOffers.preview.information.downloadAll' | translate }}</span>
            </button>
        </div>

        <div class="documents-list">
            <div class="d-flex justify-content-between document-item py-3" *ngFor="let doc of specialOffer?.campaignDocuments">
                <div class="d-flex align-items-center">                
                    <div class="document-icon">
                        <kendo-icon HJSuppres [name]="getFileTypeIcon(doc.documentName)" class="file-icon"></kendo-icon>
                    </div>
                    <div HJSuppress class="fw-bold fs-5">{{ doc.documentName }}</div>
                </div>

                <button class="btn m-outline-btn" (click)="downloadDocument(doc)">
                    <i class="app-icon icon icon-download icon-xl"></i>
                </button>
            </div>
        </div>
    </div>
</div>
